<h1 class="h1-responsive">My Account</h1>
<ul class="nav nav-tabs nav-justified tabs-3 primary-color col-12">
    <li class="nav-item">
        <a class="nav-link waves-light waves-effect" routerLink="order" routerLinkActive="active">
            Payments
        </a>
    </li>

    <li class="nav-item" *hasPermission="'Admin'">
        <a class="nav-link waves-light waves-effect" routerLink="billing" routerLinkActive="active">
            Billing Card
        </a>
    </li>

    <li class="nav-item" *hasPermission="'Admin'">
        <a class="nav-link waves-light waves-effect" routerLink="plans" routerLinkActive="active">
            Plans
        </a>
    </li>

    <li class="nav-item" *hasPermission="'Owner'">
        <a class="nav-link waves-light waves-effect" routerLink="company" routerLinkActive="active">
            Company
        </a>
    </li>
</ul>
<div class="tab-content card col-12">
    <div class="row">
        <div class="col p-3">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/my-account/my-account.component.html